import type { Dayjs } from 'dayjs';
import { useState } from 'react';

import { TimePicker } from '@/components/common/date-picker';
import { Drawer } from '@/components/feedback/drawer';

import styles from './stop-timer-drawer.module.scss';

export type StopTimerDrawerProps = {
  open: boolean;
  onClose: () => void;
  /** Confirm the stop timer; the parent issues the command + shows the lifecycle. */
  onConfirm: () => void;
};

/**
 * Stop Timer drawer (Figma 2322-691492): Start Time + End Time pickers. Save is enabled
 * once both times are chosen.
 */
export function StopTimerDrawer({ open, onClose, onConfirm }: StopTimerDrawerProps) {
  const [start, setStart] = useState<Dayjs | null>(null);
  const [end, setEnd] = useState<Dayjs | null>(null);

  const valid = !!start && !!end;

  return (
    <Drawer
      open={open}
      onClose={onClose}
      title="Stop Timer"
      primaryText="Save"
      primaryVariant="neutral"
      onPrimary={valid ? onConfirm : undefined}
      cancelText="Cancel"
      onCancel={onClose}
    >
      <div className={styles.times}>
        <div className={styles.field}>
          <span className={styles.label}>Start Time</span>
          <TimePicker
            value={start}
            onChange={(v) => setStart(v)}
            use12Hours
            format="h:mm A"
            placeholder="Choose"
          />
        </div>
        <div className={styles.field}>
          <span className={styles.label}>End Time</span>
          <TimePicker
            value={end}
            onChange={(v) => setEnd(v)}
            use12Hours
            format="h:mm A"
            placeholder="Choose"
          />
        </div>
      </div>
    </Drawer>
  );
}
